import React from 'react';
import PropTypes from 'prop-types';

import { DELETE_MODAL } from '../../../constants';
import CircleSpinner from '../../../assets/svg/CircleSpinner';

export const DeleteConfirmationModal = ({
    isDeleteModal,
    setIsDeleteModal,
    selectedItemId,
    handleDeleteClick,
    isDisabled,
    deleteButtonName,
    extraWarningText = null,
    isLoading = false,
}) => {
    return (
        <div
            className={`modal custom-modal-doc-cato fade ${isDeleteModal ? 'show' : ''}`}
            tabIndex={-1}
            aria-labelledby='exampleModalLabel'
            aria-hidden={!isDeleteModal}
            role='dialog'
            style={{ display: isDeleteModal ? 'block' : 'none' }}
        >
            <div className='modal-dialog w-100'>
                <div className='modal-content border-0'>
                    <div className='d-flex align-items-center justify-content-end'>
                        <button
                            type='button'
                            className='btn-close'
                            data-bs-dismiss='modal'
                            aria-label='Close'
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsDeleteModal(false);
                            }}
                        />
                    </div>
                    <div className='modal-body p-0'>
                        <h3 className='text-center del-title mt-0' style={{ fontSize: '30px' }}>
                            {`${DELETE_MODAL.DELETE_HEADING} `}
                            <b
                                className='break-anywhere '
                                title={deleteButtonName}
                                style={{ fontWeight: 600 }}
                            >
                                {deleteButtonName}
                            </b>
                            ?
                        </h3>
                        <p className='text-center del-para mt-3 mb-4 text-danger'>
                            {DELETE_MODAL.PARA_TEXT}
                            <br />
                            {DELETE_MODAL.UNDO_TEXT}
                            <br />
                            {extraWarningText}
                        </p>
                    </div>
                    <div className='d-flex align-items-center justify-content-center modal-btn'>
                        <button
                            type='button'
                            className='ssc-secondary-white-btn disabled-hover'
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClick({ selectedItemId, setIsDeleteModal });
                            }}
                            disabled={isDisabled || isLoading}
                        >
                            {isLoading && (
                                <span className='me-1'>
                                    <CircleSpinner />
                                </span>
                            )}
                            {DELETE_MODAL.DELETE_BUTTON}
                        </button>
                        <button
                            type='button'
                            className='ssc-primary-green-btn py-0 w-auto'
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsDeleteModal(false);
                            }}
                            disabled={isLoading}
                        >
                            {'Cancel'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

DeleteConfirmationModal.propTypes = {
    isDeleteModal: PropTypes.bool,
    setIsDeleteModal: PropTypes.func,
    selectedItemId: PropTypes.string,
    handleDeleteClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    deleteButtonName: PropTypes.string.isRequired,
    extraWarningText: PropTypes.string,
};
